
import {initWebComponent} from "@/helpers/web-component-helper";
import {getActiveFilterFormAttributeByKey, getActiveFilterUrl} from "@/helpers/filter/filter-helper";
import {getFilterDomainList} from "@/http/services/http-services-filter";
import {blockUi, unblockUi} from "@/modules/elements-blockui";
import {updateFilterBadge} from "@/helpers/filter/filter-settings-helper";
import {setUpNumericObserver} from "@/helpers/filter/filter-numeric-helper";

export class LayerInfoFilterSettingsNumericBetweenComponent extends HTMLElement {
    constructor(){
        super();

        const key = this.getAttribute('data-key')
        const formAttribute = getActiveFilterFormAttributeByKey(key)

        const template = document.createElement('template');
        template.innerHTML = `
        <div class="row">
            <div class="col-2"><div class="form-group mt-2">Van</div></div>
            <div class="col-4"><input type="number" class="form-control" value="` + formAttribute.Prefix + `"></div>
            <div class="col-2"><div class="form-group mt-2">Tot</div></div>
            <div class="col-4"><input type="number" class="form-control" value="` + formAttribute.Suffix + `"></div>
        </div>
        `;

        initWebComponent(this, template)

        if(!formAttribute.Prefix && !formAttribute.Suffix) {
            setUpNumericObserver(this, formAttribute)
        }

        setBadge(this)
        this.addEventListener('keyup', () => {
            setBadge(this)
        })

        function setBadge(element) {
            let values = []
            element.querySelectorAll('input').forEach( element => {
                if(element.value !== "") {
                    values.push(element.value)
                }
            })
            let value = ''
            if(values.length === 2) {
                value = values.join(' - ')
            }
            updateFilterBadge(element, value)
        }
    }
}
